import { RetrievalQueries } from "@faire/retailer-visitor-shared/features/RetrievalQueries/RetrievalQueries";
import { IGetSDUIFilteredComponentsResponse } from "@faire/web-api--source/indigofair/data/IGetSDUIFilteredComponentsResponse";
import React from "react";

export const SDUIRetrievalQueriesRenderer = ({
  filterableComponentsResponse,
}: {
  filterableComponentsResponse: IGetSDUIFilteredComponentsResponse | undefined;
}) => {
  const components = filterableComponentsResponse?.layout_components?.components || filterableComponentsResponse?.components;
  const componentWithRequestId = components?.find(
    (component) => component.logging_data?.request_id !== undefined
  );
  const requestId = componentWithRequestId?.logging_data?.request_id;
  return (
    <RetrievalQueries
      allRetrievalQueries={
        filterableComponentsResponse?.retrieval_debug_info_queries
      }
      requestId={requestId}
    />
  );
};
